import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const links = [
  { to: "/space", label: "The Space" },
  { to: "/availability", label: "Availability" },
  { to: "/faq", label: "FAQs & Contact" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-black/5 bg-bone/80 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-8 lg:px-16">
        <Link to="/" data-testid="nav-brand-logo" aria-label="The Owl's Nest home">
          <Logo />
        </Link>
        <nav className="hidden items-center gap-8 lg:flex" aria-label="Primary">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to}
              className={({ isActive }) =>
                `text-sm font-medium tracking-wide transition-colors ${isActive ? "text-ink" : "text-stone-500 hover:text-ink"}`}>
              {l.label}
            </NavLink>
          ))}
          <Link to="/availability" data-testid="nav-check-availability-button"
            className="btn-dark !px-5 !py-2.5 text-xs">
            Check Availability
          </Link>
        </nav>
        <button className="lg:hidden" data-testid="nav-mobile-menu-button" aria-label="Open menu"
          onClick={() => setOpen(!open)}>
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <nav className="border-t border-black/5 bg-bone px-4 pb-6 pt-2 lg:hidden" aria-label="Mobile">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)}
              className="block py-3 font-serif text-2xl text-ink">
              {l.label}
            </Link>
          ))}
          <Link to="/availability" onClick={() => setOpen(false)} className="btn-dark mt-3 w-full">
            Check Availability
          </Link>
        </nav>
      )}
    </header>
  );
};
